import { InjectionToken } from '@angular/core';
import { environment } from '../../../environments/environment';

export interface CacheStorageLike { keys(): Promise<string[]>; delete(cacheName: string): Promise<boolean>; }

/** This origin's Cache Storage; null where there is none (http:// page that is not localhost, old browser) or access throws. Specs inject a fake or null. */
export const SW_CACHE_STORAGE = new InjectionToken<CacheStorageLike | null>('SW_CACHE_STORAGE', {
  providedIn: 'root',
  factory: () => { try { return typeof caches !== 'undefined' && caches ? (caches as CacheStorageLike) : null; } catch { return null; } },
});

/** A service-worker data group's stores: 'ngsw:<scope>:<version>:data:<group>:cache' and 'ngsw:<scope>:db:<version>:data:<group>:lru|age'
 *  (e.g. 'ngsw:/:1:data:api-fresh:cache'; names checked against @angular/service-worker 22.1.7 ngsw-worker.js DataGroup/CacheDatabase).
 *  App files ('…:assets:…') and the control table ('ngsw:<scope>:db:control') never match. */
const SW_DATA_CACHE = /^ngsw:.*:\d+:data:/;
export function isSwDataCacheName(name: unknown): boolean { return typeof name === 'string' && SW_DATA_CACHE.test(name); }

/** DISC-012: deletes every API reply a service worker saved on this device. Never throws; resolves to the number deleted. */
export async function purgeSwDataCaches(storage: CacheStorageLike | null | undefined): Promise<number> {
  if (!storage) return 0;
  try {
    const names = (await storage.keys()).filter(isSwDataCacheName);
    const done = await Promise.all(names.map(n => Promise.resolve().then(() => storage.delete(n)).catch(() => false)));
    return done.filter(Boolean).length;
  } catch { return 0; }
}

/** A request to this app's API: the only requests that get 'ngsw-bypass' (a third-party URL must not get a custom header: CORS). */
export function isApiUrl(url: string, apiUrl: string = environment.apiUrl): boolean {
  return typeof url === 'string' && !!apiUrl && url.startsWith(apiUrl);
}
